import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'

import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/product/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import HeaderMenuManage from './HeaderMenuManage'

const HeaderMenu = () => {
    const settingcontext = useContext(SettingContext)
    const usercommoncontext = useContext(UserCommonContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const { allLocations, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(true)

    const {
        searchTableFetch,
        searchTableAction,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        menu_name: '',
        menu_value: '',
        type: '',
        menu_type: '',
    })

    const toggleFullScreenPopup = (popup, status, id, data) => {
        if (popup) {
            setManage({
                popup,
                status,
                id,
                menu_name: data?.menu_name || '',
                menu_value: data?.menu_value || '',
                type: data?.type || 'header',
                menu_type: data?.menu_type || 'tag',
            })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])

    const tableBodyRef = useRef(tableBody)
    useEffect(() => {
        tableBodyRef.current = tableBody
    })

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            id: 0,
            table: 'header_menus',
            deleteEntry: true,
        },
        onSubmit: (values) => {
            const dataValue = values
            if (
                dataValue.action === 'active' ||
                dataValue.action === 'deactive' ||
                dataValue.action === 'delete'
            ) {
                delete dataValue.action
                searchTableAction(values)
            }
        },
    })

    const formikView = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            primaryTable: 'header_menus',
            filters: true,
            filters: {
                menu_name: {
                    value: '',
                    type: 'like',
                    field: 'hm.menu_name',
                },
                menu_value: {
                    value: '',
                    type: 'like',
                    field: 'hm.menu_value',
                },
            },
        },
        onSubmit: (values) => {
            searchTableFetch(values, 'header_menus')
        },
    })

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'header_menus') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        searchTableFetch(formikView.values, 'header_menus')
    }, [])

    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'CommunicationSearchTable' &&
                responseStatusSetting.status === 'success'
            ) {
                setChangeStatus(false)
                setTableBody([])
                getGlobalVariable()
                searchTableFetch(formikView.values, 'header_menus')
            }
        }
    }, [responseStatusSetting])

    const onClickEdit = (id, secondaryID, type) => {
        const template = tableBodyRef.current?.filter((cat) => cat.id === id)
        toggleFullScreenPopup(true, 'edit', id, template[0])
    }

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
            filterable: true,
            filterField: 'id',
        },
        {
            field: 'menu_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Menu Title',
            filterable: true,
            filterField: 'menu_name',
        },
        {
            field: 'menu_value',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Keywords',
            filterable: true,
            filterField: 'menu_value',
        },
        {
            field: 'action',
            type: 'button',
            clickType: 'edit',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            tooltipTitle: 'Edit Menu',
        },
    ]

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (
            action === 'active' ||
            action === 'deactive' ||
            action === 'delete'
        ) {
            setChangeStatus(true)
        }
    }

    const tableActions = []
    tableActions.push({
        label: 'Delete',
        icon: <span className="material-icons">cancel</span>,
        onclick: onSelectMultiProducts,
        type: 'delete',
    })

    const searchInfo = [
        {
            label: 'Menu Title ',
            placeholder: 'Enter Title',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'menu_name',
            filter: true,
            formik: formikView,
        },
    ]

    return (
        <Layout>
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formikView} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <Button
                        id="location_add"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New
                        Header Menu
                    </Button>
                </div>

                <CustomTable
                    formik={formikView.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={search_fetch_data}
                    changeTableFunction={searchTableFetch}
                    fromVariable={'header_menus'}
                />
            </div>
            <HeaderMenuManage data={manage} function={toggleFullScreenPopup} />

            <CustomDialog
                title={'Confirm'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to delete ?</h5>
                <div className="actionWrapper">
                    <Button
                        id="location_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="location_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default HeaderMenu
